import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip, Grid } from '@mui/material';
import {
  Instagram,
  YouTube as YouTubeIcon,
  LinkedIn,
  Email as EmailIcon,
} from '@mui/icons-material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useNavigate } from 'react-router-dom';
import { palette } from '../../styles/palette';

const Footer = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleDisplayPrivacyPolicy = () => navigate('/PrivacyPolicy');
  const handleDisplayTerm = () => navigate('/Terms');
  const handleDisplayContactUs = () => navigate('/Contactus');

  return (
    <Grid
      container
      sx={{
        backgroundColor: palette.primary,
        color: palette.white,
        padding: { xs: '16px 16px', md: '16px 32px' },
      }}
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      {/* Left Section - Text Content */}
      <Grid item xs={12} md={8}>
        <Grid
          container
          spacing={{ xs: 1, md: 2 }}
          justifyContent={{ xs: 'center', md: 'space-between' }}
          alignItems="center"
          wrap="wrap"
        >
          <Grid item>
            <Typography variant="body2">
              © Copyright {new Date().getFullYear()} All Rights Reserved.
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              onClick={handleDisplayPrivacyPolicy}
              sx={{
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Privacy policy
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              onClick={handleDisplayTerm}
              sx={{
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Terms of use
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              onClick={handleDisplayContactUs}
              sx={{
                cursor: 'pointer',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Contact us
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
              All the images in the site are designed by{' '}
              <a
                href="https://www.freepik.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: isHovered ? palette.light_gray : palette.white,
                  textDecoration: 'underline',
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                Freepik
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Right Section - Social Icons */}
      <Grid item xs={12} md={4}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-end' },
            gap: 1,
          }}
        >
          <Tooltip title="Contact" arrow>
            <IconButton
              sx={{
                backgroundColor: palette.white,
                '&:hover': { backgroundColor: palette.gray },
              }}
              onClick={() => window.open('tel:+917038585222')}
            >
              <LocalPhoneIcon sx={{ color: palette.call }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Location" arrow>
            <IconButton
              sx={{
                backgroundColor: palette.white,
                '&:hover': { backgroundColor: palette.gray },
              }}
              onClick={() =>
                window.open(
                  'https://www.google.com/maps/place/Leapot+Technologies/@18.6107072,73.8171458,17z/data=!3m1!4b1!4m6!3m5!1s0x3bc2b9000c934147:0xffa27ed77030c330!8m2!3d18.6107072!4d73.8197207!16s%2Fg%2F11xtgz5mgm?entry=ttu&g_ep=EgoyMDI1MTExMi4wIKXMDSoASAFQAw%3D%3D',
                  '_blank',
                )
              }
            >
              <LocationOnIcon sx={{ color: palette.location }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="LinkedIn" arrow>
            <IconButton
              sx={{
                backgroundColor: palette.white,
                '&:hover': { backgroundColor: palette.gray },
              }}
              onClick={() =>
                window.open(
                  'https://www.linkedin.com/company/leapot-technologies/',
                  '_blank',
                )
              }
            >
              <LinkedIn sx={{ color: palette.facebook }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Instagram" arrow>
            <IconButton
              sx={{
                backgroundColor: palette.white,
                '&:hover': { backgroundColor: palette.gray },
              }}
              onClick={() =>
                window.open(
                  'https://www.instagram.com/leapot_technologies/',
                  '_blank',
                )
              }
            >
              <Instagram sx={{ color: palette.insta }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="YouTube" arrow>
            <IconButton
              sx={{
                backgroundColor: palette.white,
                '&:hover': { backgroundColor: palette.gray },
              }}
              onClick={() =>
                window.open(
                  'https://www.youtube.com/@LeapotTechnologies',
                  '_blank',
                )
              }
            >
              <YouTubeIcon sx={{ color: 'red' }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Email" arrow>
            <IconButton
              sx={{
                backgroundColor: palette.white,
                '&:hover': { backgroundColor: palette.gray },
              }}
              onClick={() =>
                (window.location.href = 'mailto:contact@leapot.in')
              }
            >
              <EmailIcon sx={{ color: palette.mail }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
